import React, { PureComponent, createRef } from "react";
import "./VerticalBarChart.scss";
import { rawDataQuestion } from "../../global-interfaces";
import { select, range, format, interpolateNumber } from "d3";
import Classnames from "classnames";
import { SUBSET } from "../../constants";
import { checkIfMobile } from "../../utils";
const pct_format: any = format(".0%");

interface Props {
  chart: rawDataQuestion;
  color: string | null;
  inView: boolean;
}

class VerticalBarChart extends PureComponent<Props> {
  private chartRef: React.RefObject<HTMLDivElement>;
  constructor(props: Props) {
    super(props);
    this.chartRef = createRef();
  }
  componentDidUpdate(prevProps: Props) {
    const { data } = this.props.chart;
    select(this.chartRef.current)
      .selectAll(".label-data")
      .transition()
      .duration(500)
      .tween("html", function(_, j) {
        let old_value = prevProps.chart.data[j].value;
        let new_value = data[j].value;
        let that = select(this);
        let i = interpolateNumber(old_value, new_value);
        return function(t) {
          that.html(pct_format(i(t)));
        };
      });
  }

  render() {
    const { chart, color, inView } = this.props;
    const { data, chart_type } = chart;
    const vertical_type: String =
      data.length > 2
        ? "vertical-many"
        : chart_type === SUBSET
        ? SUBSET
        : "vertical-two";
    const subset_chart: boolean = vertical_type === SUBSET;

    const height =
      (this.chartRef.current && this.chartRef.current.offsetHeight) || 0;

    // single_top_label implies that this chart shares a subset (rather than sharing a measure)
    const single_top_label: boolean =
      vertical_type === SUBSET && data[0].label_group === data[1].label_group;
    // single_top_label implies that this chart shares a subset (rather than sharing a measure)
    const single_lower_label: boolean =
      vertical_type === SUBSET && data[0].label === data[1].label;

    return (
      <div
        className={Classnames("VerticalBarChart", vertical_type, color)}
        ref={this.chartRef}
      >
        {data.map((d: any, i: any) => (
          <div
            key={i}
            className={Classnames(
              vertical_type,
              "bar-group",
              "pos-" + (i < data.length / 2 ? "left" : "right")
            )}
          >
            <div
              className={Classnames(
                subset_chart ? "bar-fill" : "bar-dots",
                "pos-" + (i < data.length / 2 ? "left" : "right")
              )}
            >
              {subset_chart
                ? null
                : range(0, Math.floor(height / 20)).map((e: any, i: any) => (
                    <span key={"dot_" + i} className="dot" />
                  ))}
            </div>
            <div
              className={Classnames("bar-measure", vertical_type, {
                growUp: inView,
              })}
              style={{
                height: pct_format(d.value),
              }}
            >
              <div
                className={Classnames("label-data", {
                  mid: d.value < (checkIfMobile() ? 0.11 : 0.09),
                  small: d.value < (checkIfMobile() ? 0.07 : 0.05),
                })}
              >
                {pct_format(d.value)}
              </div>
            </div>
            {single_lower_label && i === 0 ? null : (
              <div className="label-measure">{d.label}</div>
            )}
            {/* the "subset-label" appears at the top of the gas tank chart -- so it should only appear for subset charts, and if its a single top label, should only appear if i = 1. */}
            {!subset_chart || (single_top_label && i === 0) ? null : (
              <div className="label-subset">{d.label_group}</div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default VerticalBarChart;
